import React, {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
} from 'react';
import * as yup from 'yup';
import { Form } from '@availity/form';
import {
    defaultTimelineAction,
    TimelineAction,
} from '../../../../slices/marketplace/timeline/models/timeline-actions.model';
import { TimelineEvent } from '../../../../slices/marketplace/timeline/models/timeline-event.model';
import { TimelineActionType } from '../../../../slices/marketplace/timeline/models/timeline-action-type.model';
import { TimelineParty } from '../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { MarketplaceDocumentSectionFieldValidator } from '../DocumentSectionField/MarketplaceDocumentSectionFieldValidator';
import {
    createDefaultDocumentDetails,
    DocumentDetails,
} from '../../../../slices/marketplace/timeline/models/document-details.model';
import { DocumentSection } from '../../../../slices/marketplace/timeline/models/document-section.model';
import { ActionDocumentType } from '../../../../slices/marketplace/timeline/models/enums/action-document-type.enum';
import { EngagementDocumentSource } from '../../../../slices/marketplace/timeline/models/enums/engagement-document-source';
import { MarketplaceDocumentSectionField } from '../DocumentSectionField/MarketplaceDocumentSectionField';
import { Feedback } from '@availity/form';
import '../TimelineActionYupValidator';

interface BuyerLoiSubmissionFormProps {
    onSubmit(action: TimelineAction, documentDetails?: DocumentDetails): void;
    disabled: boolean;
    timelineEvents: TimelineEvent[];
    currentEvent: TimelineEvent;
    linkedAction?: TimelineAction;
    party: TimelineParty;
    documentDetails?: DocumentDetails;
    documentDetailsList: DocumentDetails[];
    documentsSections: DocumentSection[];
    setDocumentSectionList(sections: DocumentSection[]): void;
}

export const BuyerLoiSubmissionForm = forwardRef(
    (props: BuyerLoiSubmissionFormProps, ref) => {
        const formRef = useRef<any>();

        useImperativeHandle(ref, () => ({
            handleSubmit() {
                formRef?.current?.handleSubmit();
            },
        }));

        const [documentDetails, setDocumentDetails] = useState({
            ...(props.documentDetails ??
                createDefaultDocumentDetails(
                    true,
                    undefined,
                    ActionDocumentType.Downloadable,
                    undefined,
                    EngagementDocumentSource.BuyerUpload,
                    TimelineParty.VetValue
                )),
        });

        return (
            <Form
                innerRef={formRef}
                initialValues={{
                    actionType: TimelineActionType.BuyerLoiSubmission,
                    documentSection: documentDetails.sectionId,
                }}
                validationSchema={yup.object().shape({
                    actionType: yup
                        .number()
                        .uniqueActionValidation(
                            props.timelineEvents ?? [],
                            props.currentEvent
                        ),
                    documentSection:
                        MarketplaceDocumentSectionFieldValidator.documentSectionValidationRules(
                            props.documentsSections,
                            props.party
                        ),
                })}
                onSubmit={(values) => {
                    let docDetails = {
                        ...documentDetails,
                        name: 'NA',
                        sectionId: values.documentSection,
                    };

                    props.onSubmit(
                        {
                            ...defaultTimelineAction,
                            actionType: TimelineActionType.BuyerLoiSubmission,
                            referenceItemId: docDetails.id,
                        },
                        docDetails
                    );
                }}>
                <Feedback name="actionType" />
                <MarketplaceDocumentSectionField
                    disabled={props.disabled}
                    documentDetailsList={props.documentDetailsList}
                    documentsSections={props.documentsSections}
                    setDocumentSectionList={props.setDocumentSectionList}
                    type={'buyers'}
                    sectionsModalMode={'built-in'}
                />
            </Form>
        );
    }
);
